import {Navigation, Pagination, EffectFade, Controller, Autoplay} from "swiper/modules";
import Swiper from "swiper";

import "swiper/css";
import "swiper/bundle";
Swiper.use([Navigation, Pagination, EffectFade, Controller, Autoplay]);

import Shuffle from "shufflejs";
import Breakpoints from "../../utils/_breakpoints";

const sliderSelector = ".js-slider-partner";

const initSlider = () => {
    if(document.querySelector(sliderSelector)) {
        new Swiper(sliderSelector, {
            slidesPerView: 1.2,
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
            },
            duration: 1,
            freeMode: true,
            speed: 15000,
            spaceBetween: 24,
            breakpoints: {
                [Breakpoints.getValues().md]: {
                    slidesPerView: 2.5,
                },
                [Breakpoints.getValues().lg]: {
                    slidesPerView: 3.5,
                }
            }
        });
    }
};

class Filters {

    constructor(selector) {

        const wrapper = document.querySelector(selector);

        if(wrapper) {
            const element = wrapper.querySelector(".js-shuffle");

            this.className = "btn--filter--active";

            if(element) {

                this.addMore = Array.from(wrapper.querySelectorAll('.js-shuffle-add'));
                this.categories = Array.from(wrapper.querySelectorAll('.js-shuffle-filter'));

                this.shuffle = new Shuffle(element);

                this.filters = {
                    categories: [],
                    addMore: ["visible"],
                };

                this.maxItems = element.dataset.max;

                this.filter();

                this.addMore.forEach((button) => {
                    button.addEventListener('click', (e) => this._handleChange(e, this.addMore, "addMore"));
                }, this);

                this.categories.forEach((button) => {
                    button.addEventListener('click', (e) => this._handleChange(e, this.categories, "categories"));
                }, this);

                Shuffle.ShuffleItem.Scale = {
                    VISIBLE: 1,
                    HIDDEN: 1,
                };

            }
        }

    }

    _getCurrentFilters(elements) {
        return elements.filter((button) => button.classList.contains(this.className)).map((button) => button.dataset.value);
    }

    _handleChange(evt, elements, filter) {
        const button = evt.currentTarget;

        if(button.classList.contains('js-shuffle-add')) {
            if(this.filters[filter].indexOf('hidden') !== -1) {
                this.filters[filter] = ["visible"];
                button.innerHTML = "Voir plus";
            }
            else {
                this.filters[filter].push("hidden");
                button.innerHTML = "Voir moins";
            }
        }
        else {
            if (button.classList.contains(this.className)) {
                return;
            }

            elements.forEach((btn) => {
                btn.classList.remove(this.className);
            });

            button.classList.add(this.className);

            if(button.dataset.value === "all") {
                this.filters[filter] = ["all"];
            }
            else {
                this.filters[filter] = this._getCurrentFilters(elements);
            }

            const categoryItems = document.querySelectorAll("[data-category-" + this.filters.categories[0] + "]");
            if(categoryItems && this.addMore[0]) {
                if(categoryItems.length > this.maxItems || this.filters.categories[0] === "all") {
                    this.addMore[0].style.display = "inline-block";
                }
                else {
                    this.addMore[0].style.display = "none";
                }
            }

        }

        this.filter();
    }

    setEqualHeight() {
        const heights = this.shuffle.items.map(item => {
            return item.element.offsetHeight;
        });
        const maxHeight = Math.max(...heights);
        this.shuffle.items.map(item => {
            return item.element.style.height = maxHeight + "px";
        });
    }

    filter() {
        this.setEqualHeight();
        if (this.hasActiveFilters()) {
            this.shuffle.filter(this.itemPassesFilters.bind(this));
        }
    }

    hasActiveFilters() {
        return Object.keys(this.filters).some((key) => {
            return this.filters[key].length > 0;
        }, this);
    }

    itemPassesFilters(element) {

        const selectedCategory = this.filters.categories[0];
        let currentCategory = element.dataset['category-' + selectedCategory];

        if (this.filters.addMore.length && this.filters.addMore.indexOf(element.dataset.visible) === -1 && currentCategory !== "visible") {
            return false;
        }

        const categories = element.dataset.categories ? JSON.parse(element.dataset.categories) : [];

        if (categories.length && this.filters.categories.length) {
            if(selectedCategory === "all") {
                return true;
            }
            if(categories.indexOf(selectedCategory) === -1) {
                return false;
            }
        }

        return true;
    }
}

if (window.acf) {
    window.acf.addAction('render_block_preview/type=partners-block', () => {
        new Filters(".js-shuffle-partners");
        initSlider();
    });
} else {
    new Filters(".js-shuffle-partners");
    initSlider();
}
